import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { cn } from '@/lib/utils';

const baseBtn =
  'inline-flex min-h-11 min-w-[150px] items-center justify-center gap-2 rounded-[var(--bethere-radius-md)] px-5 font-bold outline-none transition-all hover:-translate-y-px [&_svg]:shrink-0';

const lightClasses =
  'border-2 border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground';

const darkClasses =
  'border border-transparent bg-primary text-primary-foreground shadow-sm hover:bg-[#5a00d6] hover:shadow-md';

const deleteClasses =
  'mr-4 border-2 border-transparent bg-white text-[#c9302c] hover:bg-[#c9302c] hover:text-white';

export const Button = ({ mode, className, ...props }) =>
  mode === 'dark' ? (
    <button className={cn(baseBtn, darkClasses, className)} {...props} />
  ) : (
    <button className={cn(baseBtn, lightClasses, className)} {...props} />
  );

export const FormButtons = ({ title, showDelete, onDelete, ...props }) => (
  <div className="mt-4 flex flex-nowrap justify-end gap-3">
    {showDelete && (
      <button
        type="button"
        className={cn(baseBtn, deleteClasses)}
        onClick={onDelete}
      >
        <FontAwesomeIcon icon={['fas', 'trash']} />
        Delete
      </button>
    )}
    <button type="submit" className={cn(baseBtn, darkClasses)}>
      <FontAwesomeIcon icon={['far', 'save']} />
      Save {title}
    </button>
  </div>
);
